export const GET_ORDER_INFO = 'orders-modal/GET_ORDER_INFO';
export const getOrderInfoAction = id => ({
	type: GET_ORDER_INFO,
	id,
});

export const SET_ORDER_INFO = 'orders-modal/SET_ORDER_INFO';
export const setOrderInfoAction = payload => ({
	type: SET_ORDER_INFO,
	payload,
});

export const SET_IS_ORDER_INFO_LOADING = 'orders-modal/SET_IS_ORDER_INFO_LOADING';
export const setIsOrderInfoLoadingAction = payload => ({
	type: SET_IS_ORDER_INFO_LOADING,
	payload,
});

export const GET_CUSTOMERS = 'orders-modal/GET_CUSTOMERS';
export const getCustomersAction = id => ({
	type: GET_CUSTOMERS,
	id,
});

export const SET_CUSTOMERS = 'orders-modal/SET_CUSTOMERS';
export const setCustomersAction = payload => ({
	type: SET_CUSTOMERS,
	payload,
});

export const SET_IS_CUSTOMERS_LOADING = 'orders-modal/SET_IS_CUSTOMERS_LOADING';
export const setIsCustomersLoadingAction = payload => ({
	type: SET_IS_CUSTOMERS_LOADING,
	payload,
});

export const GET_MODES = 'orders-modal/GET_MODES';
export const getModesAction = () => ({
	type: GET_MODES,
});

export const SET_IS_MODES_LOADING = 'orders-modal/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const SET_MODES = 'orders-modal/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const GET_PARTNERS = 'orders-modal/GET_PARTNERS';
export const getPartnersAction = payload => ({
	type: GET_PARTNERS,
	payload,
});

export const SET_IS_PARTNERS_LOADING = 'orders-modal/SET_IS_PARTNERS_LOADING';
export const setIsPartnersLoadingAction = payload => ({
	type: SET_IS_PARTNERS_LOADING,
	payload,
});

export const SET_PARTNERS = 'orders-modal/SET_PARTNERS';
export const setPartnersAction = payload => ({
	type: SET_PARTNERS,
	payload,
});

export const SET_PARTNER_SEARCH_VALUE = 'orders-modal/SET_PARTNER_SEARCH_VALUE';
export const setPartnerSearchValueAction = payload => ({
	type: SET_PARTNER_SEARCH_VALUE,
	payload,
});

export const GET_ADDRESSES = 'orders-modal/GET_ADDRESSES';
export const getAddressesAction = payload => ({
	type: GET_ADDRESSES,
	payload,
});

export const SET_IS_ADDRESSES_LOADING = 'orders-modal/SET_IS_ADDRESSES_LOADING';
export const setIsAddressesLoadingAction = payload => ({
	type: SET_IS_ADDRESSES_LOADING,
	payload,
});

export const SET_ADDRESSES = 'orders-modal/SET_ADDRESSES';
export const setAddressesAction = payload => ({
	type: SET_ADDRESSES,
	payload,
});

export const SET_ADDRESS_SEARCH_VALUE = 'orders-modal/SET_ADDRESS_SEARCH_VALUE';
export const setAddressSearchValueAction = payload => ({
	type: SET_ADDRESS_SEARCH_VALUE,
	payload,
});

export const GET_CONTACTS = 'orders-modal/GET_CONTACTS';
export const getContactsAction = payload => ({
	type: GET_CONTACTS,
	payload,
});

export const SET_CONTACTS = 'orders-modal/SET_CONTACTS';
export const setContactsAction = payload => ({
	type: SET_CONTACTS,
	payload,
});

export const SET_IS_CONTACTS_LOADING = 'orders-modal/SET_IS_CONTACTS_LOADING';
export const setIsContactsLoadingAction = payload => ({
	type: SET_IS_CONTACTS_LOADING,
	payload,
});

export const SET_CONTACT_SEARCH_VALUE = 'orders-modal/SET_CONTACT_SEARCH_VALUE';
export const setContactSearchValueAction = payload => ({
	type: SET_CONTACT_SEARCH_VALUE,
	payload,
});

export const CREATE_ORDER = 'orders-modal/CREATE_ORDER';
export const createOrderAction = payload => ({
	type: CREATE_ORDER,
	payload,
});

export const SET_IS_ORDER_SAVING = 'orders-modal/SET_IS_ORDER_SAVING';
export const setIsOrderSavingAction = payload => ({
	type: SET_IS_ORDER_SAVING,
	payload,
});

export const DELETE_ORDER = 'orders-modal/DELETE_ORDER';
export const deleteOrderAction = payload => ({
	type: DELETE_ORDER,
	payload,
});

export const SET_IS_ORDER_DELETING = 'orders-modal/SET_IS_ORDER_DELETING';
export const setIsOrderDeletingAction = payload => ({
	type: SET_IS_ORDER_DELETING,
	payload,
});

export const UPDATE_ORDER = 'orders-modal/UPDATE_ORDER';
export const updateOrderAction = payload => ({
	type: UPDATE_ORDER,
	payload,
});

export const RESET_STATE = 'orders-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
